import { render, staticRenderFns } from "./Uzytkownicy.vue?vue&type=template&id=5578e3ec&scoped=true&"
import script from "./Uzytkownicy.vue?vue&type=script&lang=js&"
export * from "./Uzytkownicy.vue?vue&type=script&lang=js&"
import style0 from "./Uzytkownicy.vue?vue&type=style&index=0&id=5578e3ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5578e3ec",
  null
  
)

export default component.exports